import { ProjectionFunctionConstructor, VictoryAreaData } from "./linearProjection";

export interface ComponentAmount {
  day: number,
  amount: number,
}

// Prepare data for each component
export const getMixtureDataPerComponent = (data: Map<number, ComponentAmount[]>, projectionFunctionConstructor: ProjectionFunctionConstructor, maxDay: number)=> {
    // Collect all mixture data for the specific component
    
    const collectedData = new Map<number, VictoryAreaData[]>(Array.from(data.keys()).map((componentId) => ([componentId, []])))
    const dataIterator = data.entries();
    dataIterator.next();

    data.forEach((componentDays, componentId) => {
      const victoryValues = [] as VictoryAreaData[];
      const dataIterator = componentDays.entries();
      dataIterator.next();
      componentDays.forEach((componentDay) => {
        const nextComponentDay = dataIterator.next();
        const y0 = componentDay.amount;
        const value = {x:componentDay.day, y: y0};
        if (nextComponentDay.done) {
          victoryValues.push(value, {x: componentDay.day+1, y: y0});
          return;
        }
        const nextComponentDayValue = nextComponentDay.value[1];
        if (nextComponentDayValue.day-componentDay.day-1 === 0 || maxDay > 250) {
          victoryValues.push(value);
          return;
        }
        const projectionFunction = projectionFunctionConstructor({x: componentDay.day, y: y0}, {x: nextComponentDayValue.day, y: nextComponentDayValue.amount})
        const valueArray = Array.from({length: nextComponentDayValue.day-componentDay.day-1}, (_, i) => (projectionFunction(componentDay.day+i+1)));
        victoryValues.push(value, ...valueArray);
      })
      collectedData.set(componentId, victoryValues);
    })
    return collectedData;
  };
  
